
import { NavLink } from "react-router-dom"

export default function NavBar() {
    return (
        <header className="bg-sky-800">
            <div className="container mx-auto flex justify-between">
                <nav className="flex">
                    <NavLink
                        to={"/"}
                        exact="true"
                        // activeClassName="text-green"
                        className="inflex-flex items-center py-6 px-3 mr-4 text-red-200 hover:text-red-400 text-4xl font-bold cursive tracking-widest">Home</NavLink>
                    <NavLink
                        to={"/about"}
                        // activeClassName="text-white"
                        className="inflex-flex items-center py-6 px-3 mr-4 text-red-200 hover:text-red-400 text-4xl font-bold cursive tracking-widest">
                        About
                    </NavLink>
                    <NavLink
                        to={"/wine"}
                        // activeClassName="text-white"
                        className="inflex-flex items-center py-6 px-3 mr-4 text-red-200 hover:text-red-400 text-4xl font-bold cursive tracking-widest"
                    >Wine
                    </NavLink>
                </nav>
            </div>
        </header>
    )
}